import React from 'react';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import dataProvider from '../../dataProvider';
import { GET_ONE, UPDATE, translate } from 'react-admin';

const styles = theme => ({
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 250,
    marginRight: '5em',
    marginLeft: '5em',
    display: 'flex',
    flexWrap: 'wrap',
  },
});

class Locale extends React.Component {
  state = {
    locale: '',
  };

  componentDidMount() {
    dataProvider(GET_ONE, 'tenants', { id: 'me' })
      .then(response => response.data)
      .then(data => {
        this.setState({ locale: data.locale });
      });
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
    dataProvider(UPDATE, 'tenants', {
      id: 'me',
      data: { [name]: event.target.value },
    });
  };

  render() {
    const { classes, translate } = this.props;

    return (
      <Card>
        <List>
          <ListItem>
            <ListItemText primary={translate('config.title')} />
          </ListItem>
          <ListItem>
            <FormControl className={classes.formControl}>
              <InputLabel>{translate('config.locale.title')}</InputLabel>
              <Select value={this.state.locale} onChange={this.handleChange('locale')}>
                <MenuItem value="ja-jp">{translate('config.locale.ja-JP')}</MenuItem>
                <MenuItem value="en-us">{translate('config.locale.en-US')}</MenuItem>
              </Select>
            </FormControl>
          </ListItem>
        </List>
      </Card>
    );
  }
}

Locale.propTypes = {
  classes: PropTypes.object.isRequired,
};

const enhance = compose(withStyles(styles), translate);

export default enhance(Locale);
